import { Components } from '@mui/material';

export default {
  styleOverrides: { root: { padding: 0 } },
} as Components;
